function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter0_i_29_30)"
}, React.createElement("path", {
  d: "M3.10504 6C3.10504 4.34315 4.44819 3 6.10504 3H36.167C37.8238 3 39.167 4.34315 39.167 6V28.6023C39.167 29.6409 38.6298 30.6056 37.7469 31.1525L22.716 40.4646C21.748 41.0642 20.524 41.0642 19.5561 40.4646L4.5251 31.1525C3.64222 30.6056 3.10504 29.6409 3.10504 28.6023V6Z",
  fill: "url(#paint0_radial_29_30)"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter1_d_29_30)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9238 10.2139L12.9239 22.6196L17.8739 22.5902V18.3173H21.7312L25.0343 22.5864H29.7859L26.3579 18.1561C28.9875 17.6036 29.9818 15.7862 29.9818 14.2327C29.9818 12.3188 29.2168 10.2139 24.2561 10.2139L12.9238 10.2139ZM17.8585 12.9876H23.9541C23.9541 12.9876 25.1568 12.9876 25.1568 14.171C25.1568 15.3544 23.9541 15.4473 23.9541 15.4473H17.8585V12.9876Z",
  fill: "#ffffff"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter2_d_29_30)"
}, React.createElement("path", {
  d: "M16.381 27.8817C16.3672 27.8253 16.3453 27.7757 16.3155 27.7331C16.2857 27.6895 16.2484 27.6527 16.2036 27.6229C16.16 27.592 16.1088 27.5691 16.0502 27.5542C15.9927 27.5382 15.9293 27.5302 15.8601 27.5302C15.7109 27.5302 15.5836 27.5659 15.4781 27.6373C15.3737 27.7086 15.2938 27.8114 15.2384 27.9457C15.1841 28.0799 15.1569 28.2418 15.1569 28.4315C15.1569 28.6232 15.183 28.7873 15.2352 28.9237C15.2874 29.06 15.3652 29.1644 15.4686 29.2369C15.5719 29.3093 15.7003 29.3455 15.8537 29.3455C15.989 29.3455 16.1014 29.3258 16.1909 29.2864C16.2814 29.247 16.3491 29.1911 16.3938 29.1186C16.4385 29.0462 16.4609 28.9609 16.4609 28.8629L16.6143 28.8789H15.8665V28.2461H17.3175V28.6999C17.3175 28.9982 17.2541 29.2534 17.1273 29.4654C17.0016 29.6763 16.8279 29.8382 16.6063 29.9512C16.3858 30.063 16.1328 30.119 15.8473 30.119C15.5287 30.119 15.2491 30.0513 15.0083 29.916C14.7676 29.7807 14.5795 29.5879 14.4442 29.3375C14.31 29.0872 14.2429 28.7894 14.2429 28.4442C14.2429 28.1737 14.2839 27.9339 14.3659 27.7251C14.449 27.5163 14.5641 27.34 14.7111 27.1962C14.8581 27.0513 15.028 26.9421 15.2209 26.8686C15.4137 26.794 15.6204 26.7567 15.8409 26.7567C16.0348 26.7567 16.2148 26.7844 16.381 26.8398C16.5483 26.8942 16.6958 26.9719 16.8237 27.0732C16.9526 27.1733 17.0564 27.2921 17.1353 27.4295C17.2141 27.5669 17.2621 27.7177 17.2791 27.8817H16.381ZM21.3522 28.4379C21.3522 28.8022 21.2813 29.1096 21.1397 29.3599C20.998 29.6092 20.8067 29.7983 20.566 29.9272C20.3252 30.055 20.0567 30.119 19.7606 30.119C19.4623 30.119 19.1927 30.0545 18.952 29.9256C18.7123 29.7956 18.5216 29.606 18.3799 29.3567C18.2393 29.1064 18.169 28.8001 18.169 28.4379C18.169 28.0735 18.2393 27.7667 18.3799 27.5174C18.5216 27.267 18.7123 27.0779 18.952 26.9501C19.1927 26.8212 19.4623 26.7567 19.7606 26.7567C20.0567 26.7567 20.3252 26.8212 20.566 26.9501C20.8067 27.0779 20.998 27.267 21.1397 27.5174C21.2813 27.7667 21.3522 28.0735 21.3522 28.4379ZM20.4381 28.4379C20.4381 28.2418 20.412 28.0767 20.3598 27.9425C20.3087 27.8072 20.2325 27.7049 20.1313 27.6357C20.0312 27.5653 19.9076 27.5302 19.7606 27.5302C19.6136 27.5302 19.4894 27.5653 19.3882 27.6357C19.2881 27.7049 19.2119 27.8072 19.1597 27.9425C19.1086 28.0767 19.083 28.2418 19.083 28.4379C19.083 28.6339 19.1086 28.7995 19.1597 28.9348C19.2119 29.0691 19.2881 29.1713 19.3882 29.2417C19.4894 29.3109 19.6136 29.3455 19.7606 29.3455C19.9076 29.3455 20.0312 29.3109 20.1313 29.2417C20.2325 29.1713 20.3087 29.0691 20.3598 28.9348C20.412 28.7995 20.4381 28.6339 20.4381 28.4379ZM22.2133 30.0742V26.8015H23.1018V29.3583H24.4249V30.0742H22.2133ZM26.4933 30.0742H25.2341V26.8015H26.4805C26.8172 26.8015 27.108 26.867 27.353 26.998C27.5991 27.128 27.7888 27.3155 27.9219 27.5605C28.0562 27.8045 28.1233 28.0969 28.1233 28.4379C28.1233 28.7788 28.0567 29.0717 27.9235 29.3168C27.7904 29.5607 27.6018 29.7482 27.3578 29.8793C27.1139 30.0092 26.8257 30.0742 26.4933 30.0742ZM26.1226 29.32H26.4614C26.6233 29.32 26.7612 29.2939 26.8752 29.2417C26.9903 29.1895 27.0777 29.0994 27.1373 28.9716C27.198 28.8437 27.2284 28.6658 27.2284 28.4379C27.2284 28.2099 27.1975 28.032 27.1357 27.9041C27.075 27.7763 26.9855 27.6863 26.8672 27.6341C26.7501 27.5819 26.6062 27.5558 26.4358 27.5558H26.1226V29.32Z",
  fill: "#ffffff"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_i_29_30",
  x: 3.10504,
  y: 3,
  width: 36.062,
  height: 37.9143,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", null), React.createElement("feGaussianBlur", {
  stdDeviation: 5.53844
}), React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.23559 0 0 0 0 0.238151 0 0 0 0 0.245833 0 0 0 1 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_29_30"
})), React.createElement("filter", {
  id: "filter1_d_29_30",
  x: 11.4654,
  y: 10.2139,
  width: 19.9749,
  height: 15.3227,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", {
  dy: 1.45847
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.729234
}), React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_29_30"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_29_30",
  result: "shape"
})), React.createElement("filter", {
  id: "filter2_d_29_30",
  x: 10.8419,
  y: 23.3558,
  width: 20.6824,
  height: 10.1642,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", null), React.createElement("feGaussianBlur", {
  stdDeviation: 1.70049
}), React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.454902 0 0 0 0 0.32549 0 0 0 0 0.0941176 0 0 0 1 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_29_30"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_29_30",
  result: "shape"
})), React.createElement("radialGradient", {
  id: "paint0_radial_29_30",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(21.136 23.0722) rotate(90) scale(31.2663 29.6765)"
}, React.createElement("stop", {
  stopColor: "#D6AF66",
  stopOpacity: 0.95
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B68E45"
})));

var SvgGoldNoBorder = function SvgGoldNoBorder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGoldNoBorder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gold_no_border.3bdc7f3c.svg";
export { ForwardRef as ReactComponent };